module.exports = __webpack_public_path__ + "static/media/person2.235182f2.svg";